const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.27,211.61a64.17,64.17,0,0,1-4.63,7.48A63,63,0,0,1,155.05,238c-1.39-.73-2.75-1.51-4.05-2.33s-2.57-1.66-3.79-2.56c-1.48-1.07-2.9-2.21-4.26-3.4l0,0a1.65,1.65,0,0,1-.24-.22l0,0a63.08,63.08,0,1,1,97.61-17.83Z",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.16,407.57a8.14,8.14,0,0,1-3.4-.93c-17-8.87-30.22-23.53-38.18-34.05A125.73,125.73,0,0,1,211.05,360l4.08-17.48s3.84,10,19.27,19.83,33.76,13.07,39.69,23C279.34,394,270.09,408,261.16,407.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.56,382.09s-6.31-.19-14.75.09c-12.76.4-30.39,1.84-38.45,6.53l-.38-.13L245.6,386l-.15-.22c-1.36-2-12.33-17.75-28-24.16l-22.16-61.92s23,1,35.57,21.78l6.31,2.28s37.55-11.12,58.57-7.12Z",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.81,427.87c-6.35,1.73-13.25-9.43-21.67-21.61h0c-5.56-8-11.78-16.53-18.93-22-.57-.43-1.15-.85-1.73-1.25l4.18-21c8.68,4.55,14.06,11.84,23.07,19.33,14.5,12.07,27.35,19.48,30.91,24.82S365.69,424.9,354.81,427.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319,382.18a3.47,3.47,0,0,1-2,1.62,7,7,0,0,1-.69.23l-.19,0c-6.71,1.75-21.81-1.89-21.81-1.89s-9.89-4.7-10.49-5.81a27.22,27.22,0,0,1-1.11-2.7l-.27-.79s-3.56-2-4-3.56-1.19-2,1-2.28,14,0,14,0l-12.85-5.24s-8.51-4.29-9.3-5.8-1.78-2.51,2.57-1.91,13.85,3.36,13.85,3.36L295.2,359l-7.44-3.17s-14.64-1.77-11.87-6.32h8.31a85.79,85.79,0,0,1,14,1.78c2.42.74,18.42,10.68,18.42,10.68",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.78,417.62l36.62,11,67-15.29S199.48,401.71,199.1,402,136.78,417.62,136.78,417.62Z",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.31,404.72c-2.57.18-3.21,9.44-.53,12.9l59.16-12.28,4.74-11.22Z",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.2,406a8.82,8.82,0,0,1,.45,11A10.41,10.41,0,0,1,139.2,406Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "276.07 420.62 340.02 423.24 333.79 445.25 255.12 442.25 276.07 420.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.69,139.16C90.4,87.32,140,48.1,201.75,42.58A171.52,171.52,0,0,1,320.48,76.93c16.86,13,31.84,29.55,41.79,48.44,11.42,21.7,14.75,46.72,26.5,68.32,14.61,26.85,42.05,37.93,60.48,61.13,15.17,19.11,20.38,44.72,18.64,69.06-3.18,44.43-29.21,86.61-67.5,109.38-32.37,19.25-71.39,24.56-109,22.81-58-2.69-115.74-21.82-161.42-57.65s-78.51-88.8-86.29-146.33C38.39,213,46.08,173.33,63.69,139.16Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.69,139.16C90.4,87.32,140,48.1,201.75,42.58A171.52,171.52,0,0,1,320.48,76.93c16.86,13,31.84,29.55,41.79,48.44,11.42,21.7,14.75,46.72,26.5,68.32,14.61,26.85,42.05,37.93,60.48,61.13,15.17,19.11,20.38,44.72,18.64,69.06-3.18,44.43-29.21,86.61-67.5,109.38-32.37,19.25-71.39,24.56-109,22.81-58-2.69-115.74-21.82-161.42-57.65s-78.51-88.8-86.29-146.33C38.39,213,46.08,173.33,63.69,139.16Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Elements--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.07,158.11c1.18,4.68.6-3.93,2.91-14.45s6.28-6.26,6.28-6.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.35,
    y1: 147.36,
    x2: 52.6,
    y2: 144.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.59,140.82s-4.33,9,2.2,12.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.74,138.3s7.16,4,2.68,12.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.84,
    y1: 143.86,
    x2: 64.97,
    y2: 147.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.86,
    y1: 142.21,
    x2: 59.85,
    y2: 148.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.13,
    cy: 236.2,
    r: 10.91,
    transform: "translate(-169.28 273.09) rotate(-80.68)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.95,
    cy: 240.47,
    r: 12.1,
    transform: "translate(-46.47 23.19) rotate(-11.59)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.07,
    y1: 231.71,
    x2: 81.05,
    y2: 233.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.77,
    y1: 233.78,
    x2: 79.55,
    y2: 236.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.04,
    y1: 236.28,
    x2: 78.98,
    y2: 239.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.47,
    y1: 239.69,
    x2: 79.12,
    y2: 243.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.17,
    y1: 242.31,
    x2: 79.59,
    y2: 244.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4,219.59c-.31-1-3.85-1.62-4,1s3.73.44,4.83-1c0,0-2,2.69-1.16,3.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,222.85l-3.14,6.53s1.57-3.27,3.25-3c2.07.37.69,3.76-1.81,2.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.71,
    y1: 329.47,
    x2: 447.64,
    y2: 334.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.64,
    y1: 328.25,
    x2: 443.51,
    y2: 334.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.49,
    y1: 330.02,
    x2: 457.43,
    y2: 328.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.8,
    y1: 323.04,
    x2: 462.8,
    y2: 325.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 465.1,
    y1: 319.85,
    x2: 461.3,
    y2: 332.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.97 256.22 248.24 247.09 265.81 248.32 266.91 270.6 254.01 279.82 238.09 278.66 234.97 256.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "238.09 278.66 250.94 269.41 266.91 270.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.94,
    y1: 269.41,
    x2: 248.24,
    y2: 247.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "234.97 256.22 252.5 258.25 265.81 248.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.5,
    y1: 258.25,
    x2: 254.01,
    y2: 279.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.85 181.37 383.97 199.64 402.27 197.17 389.85 181.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.85,
    y1: 181.37,
    x2: 393.12,
    y2: 198.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "392.6 195.59 394.74 195.25 395.24 198.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.39,
    y1: 348.56,
    x2: 168.53,
    y2: 353.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.58,
    y1: 345.13,
    x2: 162.96,
    y2: 354.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.85,340.47a1.38,1.38,0,0,1,2.2.29c.92,1.44-.88,4.46-.88,4.46l3.67-1.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.15,34c8.73,4.91-1.27,16.91-1.27,23.91s10,6,15,8c2,0,6,0,5.89,5.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,40.37c1.52,8.27,11,5.34,16.82,7.23,10,3.25,4.45,13.57,1.47,19.81-1.79,3.72-3.57,8.94-.37,12.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.7,
    y1: 43.58,
    x2: 233.11,
    y2: 34.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.78,
    y1: 46.16,
    x2: 234.62,
    y2: 39.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.39,
    y1: 52.74,
    x2: 238.01,
    y2: 47.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.02,
    y1: 60.52,
    x2: 242.96,
    y2: 51.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.98,
    y1: 64.15,
    x2: 244,
    y2: 57.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.82,
    y1: 78.22,
    x2: 250.09,
    y2: 69.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.1,
    y1: 71,
    x2: 246.45,
    y2: 65.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.17,
    cy: 334.1,
    r: 20.94,
    transform: "translate(-118.05 55.15) rotate(-21.8)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.44,313.84c7.3-8.57,13.51-13.42,15.9-11.84,3.64,2.39-2.89,18.71-14.58,36.44S66.64,368.61,63,366.21c-2.4-1.57-.38-9.19,4.62-19.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.68,338.4c-10.18-2.93-16.68-6.35-16.27-9.08C48,325,65.59,324,86.6,327.15s37.53,9.12,36.9,13.42c-.45,3-9,4.37-21.15,3.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.35,323.23c-7.68-13.86-11.52-24.67-8.92-26.36,3.42-2.21,16.64,12.13,29.53,32s20.56,37.83,17.15,40.05c-2.26,1.46-8.81-4.32-16.72-14.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.29,311.06a3.44,3.44,0,1,1-1-4.77A3.44,3.44,0,0,1,108.29,311.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9,363.75a3.44,3.44,0,1,1-1-4.77A3.44,3.44,0,0,1,96.9,363.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.52,328a3.44,3.44,0,1,1-1-4.77A3.45,3.45,0,0,1,78.52,328Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.83 178.32 309.61 178.32 315.5 168.12 309.61 157.92 297.83 157.92 291.94 168.12 297.83 178.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.12 200.71 290.23 190.51 278.45 190.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.03 168.12 291.81 168.12 297.7 157.92 291.81 147.71 280.03 147.71 274.14 157.92 280.03 168.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.83 157.92 309.61 157.92 315.5 147.71 309.61 137.51 297.83 137.51 291.94 147.71 297.83 157.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.7,
    cy: 157.92,
    r: 1.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.1,
    cy: 136.5,
    r: 1.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.54,200.71a1.58,1.58,0,1,1,1.58,1.58A1.58,1.58,0,0,1,294.54,200.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.45,
    cy: 190.51,
    r: 1.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.9,148a1.59,1.59,0,1,1,1.58,1.59A1.58,1.58,0,0,1,326.9,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.11,
    cy: 190.51,
    r: 1.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.92,148a1.59,1.59,0,1,1,1.59,1.59A1.59,1.59,0,0,1,313.92,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.12,178.33a1.59,1.59,0,1,1,1.58,1.58A1.59,1.59,0,0,1,296.12,178.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.51,
    y1: 147.98,
    x2: 328.48,
    y2: 147.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.7,
    y1: 178.33,
    x2: 290.11,
    y2: 190.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.03,
    y1: 147.71,
    x2: 273.1,
    y2: 136.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.58,107.5a21.82,21.82,0,0,1,42.1.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,135.34a21.81,21.81,0,0,1-19.33-21.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.31,113.67a21.81,21.81,0,0,1-21.8,21.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.55,99.84c6.82-.87,11.39-.4,12.1,1.64,1.41,4.06-13.18,12.81-32.59,19.55s-36.28,8.9-37.7,4.83c-.75-2.17,3.07-5.68,9.75-9.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.11 84.9 292.2 89.13 296.87 89.81 293.49 93.11 294.29 97.76 290.11 95.56 285.93 97.76 286.73 93.11 283.35 89.81 288.02 89.13 290.11 84.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47,73.63a14.2,14.2,0,0,1-14.18,14.19q-.69,0-1.35-.06a14.19,14.19,0,1,1,15.53-14.13Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.2,76.19A2.2,2.2,0,1,1,138,74,2.2,2.2,0,0,1,140.2,76.19Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.45,81.77a3.54,3.54,0,0,1-1.28,2.73A14.06,14.06,0,0,1,115,78.71a3.45,3.45,0,0,1,1.83-.51A3.57,3.57,0,0,1,120.45,81.77Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,84a14.09,14.09,0,0,1-9.71,3.86q-.69,0-1.35-.06a5.66,5.66,0,0,1-.12-1.17A5.9,5.9,0,0,1,138,84Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.85,
    cy: 64.74,
    r: 3.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87,74a1.51,1.51,0,1,1-1.51-1.51A1.51,1.51,0,0,1,127.87,74Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8,65.35a3.82,3.82,0,0,1-1.23.19,4.15,4.15,0,0,1-4.15-4.16,4.41,4.41,0,0,1,0-.52A14.13,14.13,0,0,1,139.8,65.35Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.85,238.29l1.53-3.44-2.48-1.36a7.5,7.5,0,0,0,.05-1.83l2.54-1.24-1.35-3.51-2.72.78a7.48,7.48,0,0,0-1.26-1.32l.93-2.68-3.44-1.53-1.37,2.48a7.48,7.48,0,0,0-1.83,0l-1.23-2.54-3.52,1.35.79,2.71a8,8,0,0,0-1.33,1.27l-2.67-.93L447,229.89l2.48,1.37a7.48,7.48,0,0,0-.05,1.83l-2.55,1.23,1.35,3.52,2.72-.79a7.92,7.92,0,0,0,1.26,1.33l-.92,2.67,3.44,1.53,1.36-2.48a7.5,7.5,0,0,0,1.83.05l1.24,2.55,3.51-1.35-.78-2.72a7.86,7.86,0,0,0,1.32-1.26Zm-10.46-1.92a4.37,4.37,0,1,1,5.77-2.22A4.38,4.38,0,0,1,455.39,236.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.57,255.94l2.08-4.67-3.36-1.86a10.31,10.31,0,0,0,.06-2.48l3.46-1.68L448,240.48l-3.69,1.07a10,10,0,0,0-1.71-1.8l1.26-3.64L439.15,234l-1.85,3.36a10.87,10.87,0,0,0-2.48-.07l-1.68-3.45-4.78,1.84,1.07,3.68a10.83,10.83,0,0,0-1.8,1.72L424,239.86l-2.08,4.67,3.36,1.86a10.31,10.31,0,0,0-.06,2.48l-3.46,1.68,1.84,4.77,3.69-1.06a10.38,10.38,0,0,0,1.71,1.8l-1.26,3.63,4.68,2.08,1.85-3.37a10.33,10.33,0,0,0,2.48.07l1.68,3.45,4.78-1.83-1.07-3.69a10.77,10.77,0,0,0,1.8-1.71Zm-14.2-2.61a5.94,5.94,0,1,1,7.84-3A5.93,5.93,0,0,1,433.37,253.33Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Earth--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.27,211.61a64.17,64.17,0,0,1-4.63,7.48A63,63,0,0,1,155.05,238c-1.39-.73-2.75-1.51-4.05-2.33s-2.57-1.66-3.79-2.56c-1.48-1.07-2.9-2.21-4.26-3.4l0,0a1.65,1.65,0,0,1-.24-.22l0,0a63.08,63.08,0,1,1,97.61-17.83Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.27,211.61a64.17,64.17,0,0,1-4.63,7.48l-1.22-1-2.1-1.11-2.21-1.16.37-2.67-.12-2.41c-.13-2.41,1.61-.44,3-1.17a8.09,8.09,0,0,0,2.55-3s1-3.21.67-4.5a36.41,36.41,0,0,0-1.9-4.34l-3.58,5-3-.23L225.26,201l-.37-3.95-1.46-.76-.61-2.27-7.89-2.21-.9-1.58c-.9-1.58-4.53-2.39-4.53-2.39l.89-2.06,1.4-2.3c1.41-2.3,2.87,1.52,2.87,1.52l1.67.87,3.1-2.6.82-3.73,5.05.29a2.25,2.25,0,0,1,1.32-2.5c1.68-.66.94-4.31.3-5.66s-3-.26-3-.26-2.57-3.91-2.92-5.47,4.9-1,7.15-2.57,1.48-4.69.38-4.76,2.15-7.1,8.4-5.17c1.74.54,2.84.35,3.52-.25A63,63,0,0,1,240.27,211.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.54,184.56l-2.14,2.69s-.91-2.17-2.21-1l-2,1.78-1.45,4.06-2.6,1.68-1.59-.83-1.5-.8-1.63-.86-1.56,3-1.27,2.4a15.32,15.32,0,0,0,2.29,3.25l2.76,4.87L187,206.5a25.56,25.56,0,0,1,4.17.5l2.31,1.21-.82,5s-1.74,2.83-2.9,2.05l-1.17-.77-1.9,6.58-.08,3.62s-1.13.47-2.27.85-.42.18-2.81.92-2.2.71-4.14,1.26a26.13,26.13,0,0,0-4.75,2.22l.17,3.48-4.57.67-2.56-1.36.63-2.2.3-3.44-.35-2.57-1.1-2.27,3.08-2.79-.68-1.75-1.75-3.48-3.7,2-1.9,1-4.3-1.93-.47-2.61L154,208l-1.34-2.92-2.38-3.22-.6-2.77,1.34-2.54.71-1.34-2.19-2.95-.6-2.1-3.69-3.35s1.07-.07.83-1.56,2.11-4,2.11-4c1.33.7,5.32,3.48,5.32,3.48l3.49.48s.7,0,1.38-1.32a18.69,18.69,0,0,1,2.78-3.33s-1.61-5.59-.46-6.34,2.32-4.41,2.32-4.41l.92-1.75s-2.17-.95-2.58-2.1-5.76.38-5.76.38l-3.69,2.56L149,171.15l-1.26,2.39s-2.57-3.09-2.58-1.36a24.54,24.54,0,0,1-1.16,5.21s.53.28-.17,1.62-1.46,1.27-3,1.46a38.45,38.45,0,0,1-6-.41s-1,3.7-.31,4.34l.68.62s-1.07,2.69-2.13,2.13l-2.58-1.36-3.61,1.46-4,4.42-.89-.18a63.08,63.08,0,0,1,52.49-71.6c.23,1,.48,1.94.48,1.94l-1,4.94-1.28,2.44-1.1,2.09-1.55,2.94L174,137.9l-.85,4.33L171,143.58l-.62,3.25,3.69,7.21,1,2.83a9.91,9.91,0,0,0-.89,4.32s.45,2.7,2.42,3.77,4.56,2.33,4.56,2.33l-.21,4-.89,1,1.48,4.31c4.51,1.77,4.08,3.25,4.51,1.77l.44-1.47,3.07-1.11,3.91,4.67a2.71,2.71,0,0,1,2.3,1.22C196.91,183.12,198.69,181.87,196.54,184.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.54,219.39c.11,1.42-1.69,3.2-1.69,3.2l1.47.77.45,4-1.11,2.12a62.82,62.82,0,0,1-17.45-25.62l.8-4.24,3.53-.5s3.16-2.1,4.56-1.54,2.68,4,2.68,4,1,4.64.87,4.55h0l-.06,0,.08,0,1.44.76.41,1.83-2,3.8h-3.22s-.64-.34-.7,1.33a4.06,4.06,0,0,0,1.67,2.93l3.48-.89.93-3.6,3.42-.67s-.49,2.21.31,2.63l.81.43.48,2.64A2.37,2.37,0,0,0,143.54,219.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.08,225.05c-.31-.86-.44-1.61-2.57-2.73s-2-.72-2.84.21a3.07,3.07,0,0,1-3.18,1.13c-1.4-.31-.67,1.27-.67,1.27l.34,4.27-3.95,3.9q1.83,1.35,3.79,2.56l.84-2.58L158.4,235c-1.39-.41-.57-2.31-.57-2.31l-1.4-.74S160.39,225.89,160.08,225.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.4,202.85l-2.15-2.17-2.46.77-1,2-.75,1.44,1,2,2,2.43,1.14-2.18s3.17,0,4.83-1.83S201.4,202.85,201.4,202.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.08,193.06l4,2.1.16-.94a5.43,5.43,0,0,1,1.08-2.05l-3.06-3.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.72,239.61l-1.15-1.69-1.34-.7h-4.09l-2.33,4.42s-2.23-.3-5.16-.56-2.21.95-2.21.95l-.76,2.78a63.24,63.24,0,0,0,22.14-1.19A28,28,0,0,0,196.2,242Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M240.27,211.61a64.17,64.17,0,0,1-4.63,7.48A63,63,0,0,1,155.05,238c-1.39-.73-2.75-1.51-4.05-2.33s-2.57-1.66-3.79-2.56c-1.48-1.07-2.9-2.21-4.26-3.4l0,0a1.65,1.65,0,0,1-.24-.22l0,0a63.08,63.08,0,1,1,97.61-17.83Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.82,243.62a63.24,63.24,0,0,1-22.14,1.19l.76-2.78s-.72-1.21,2.21-.95,5.16.56,5.16.56l2.33-4.42h4.09l1.34.7,1.15,1.69L196.2,242A28,28,0,0,1,198.82,243.62Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.49,153.2c-.68.6-1.78.79-3.52.25-6.25-1.93-9.49,5.09-8.4,5.17s1.86,3.24-.38,4.76-7.5,1-7.15,2.57,2.92,5.47,2.92,5.47,2.3-1.08,2.95.26,1.39,5-.29,5.66a2.25,2.25,0,0,0-1.32,2.5l-5.05-.29-.82,3.73-3.1,2.6-1.67-.87s-1.46-3.82-2.87-1.52l-1.4,2.3-.89,2.06s3.63.81,4.53,2.39l.9,1.58,7.89,2.21.61,2.27,1.46.76.37,3.95,2.94,1.54,3,.23,3.58-5a36.41,36.41,0,0,1,1.9,4.34c.35,1.29-.67,4.5-.67,4.5a8.09,8.09,0,0,1-2.55,3c-1.43.73-3.18-1.24-3,1.17l.12,2.41-.37,2.67,2.21,1.16,2.1,1.11,1.22,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.07,191.49l.89.18,4-4.42,3.61-1.46,2.58,1.36c1.06.56,2.13-2.13,2.13-2.13l-.68-.62c-.69-.64.31-4.34.31-4.34a38.45,38.45,0,0,0,6,.41c1.58-.19,2.33-.13,3-1.46s.17-1.62.17-1.62a24.54,24.54,0,0,0,1.16-5.21c0-1.73,2.58,1.36,2.58,1.36l1.26-2.39,2.82-2.24,3.69-2.56s5.35-1.54,5.76-.38,2.58,2.1,2.58,2.1l-.92,1.75s-1.18,3.64-2.32,4.41.46,6.34.46,6.34a18.69,18.69,0,0,0-2.78,3.33c-.7,1.34-1.38,1.32-1.38,1.32l-3.49-.48s-4-2.78-5.32-3.48c0,0-2.35,2.51-2.11,4s-.83,1.56-.83,1.56l3.69,3.35.6,2.1,2.19,2.95-.71,1.34-1.34,2.54.6,2.77,2.38,3.22L154,208l1.46,4.71.47,2.61,4.3,1.93,1.9-1,3.7-2,1.75,3.48.68,1.75-3.08,2.79,1.1,2.27.35,2.57-.3,3.44-.63,2.2,2.56,1.36,4.57-.66-.17-3.49a26.13,26.13,0,0,1,4.75-2.22c1.94-.55,1.75-.52,4.14-1.26s1.66-.54,2.81-.92,2.27-.85,2.27-.85l.08-3.62,1.9-6.58,1.17.77c1.16.78,2.9-2.05,2.9-2.05l.82-5L191.14,207a25.56,25.56,0,0,0-4.17-.5l-3.29-1.73-2.76-4.87a15.32,15.32,0,0,1-2.29-3.25l1.27-2.4,1.56-3,1.63.86,1.5.8,1.59.83,2.6-1.68,1.45-4.06,2-1.78c1.3-1.18,2.21,1,2.21,1l2.14-2.69c2.15-2.69.37-1.44-.73-2.82a2.71,2.71,0,0,0-2.3-1.22l-3.91-4.67L186.53,177l-.44,1.47c-.43,1.48,0,0-4.51-1.77l-1.48-4.31.89-1,.21-4s-2.59-1.27-4.56-2.33-2.42-3.77-2.42-3.77a9.91,9.91,0,0,1,.89-4.32l-1-2.83-3.69-7.21.62-3.25,2.15-1.35.85-4.33-3.86-3.66,1.55-2.94,1.1-2.09,1.28-2.44,1-4.94s-.25-.92-.48-1.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,229.7a1.62,1.62,0,0,0-.26-.24l0,0,1.11-2.12-.45-4-1.47-.77s1.8-1.78,1.69-3.2a2.37,2.37,0,0,1,1.13-2.13l-.48-2.64-.81-.43c-.8-.42-.31-2.63-.31-2.63l-3.42.67-.93,3.6-3.48.89a4.06,4.06,0,0,1-1.67-2.93c.06-1.67.7-1.33.7-1.33h3.22l2-3.8-.41-1.83-1.44-.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.63,206.05h0c.16.09-.87-4.55-.87-4.55s-1.28-3.39-2.68-4-4.56,1.54-4.56,1.54l-3.53.5-.8,4.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.84,233.08l-.84,2.58q-2-1.22-3.79-2.56l3.95-3.9-.34-4.27s-.73-1.58.67-1.27a3.07,3.07,0,0,0,3.18-1.13c.82-.93.72-1.33,2.84-.21s2.26,1.87,2.57,2.73-3.65,6.93-3.65,6.93l1.4.74s-.82,1.9.57,2.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.79,201.45l2.46-.77,2.15,2.17s4.25.55,2.59,2.4-4.83,1.83-4.83,1.83L198,209.26l-2-2.43-1-2,.75-1.44Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.32,192.17a5.43,5.43,0,0,0-1.08,2.05l-.16.94-4-2.1,2.18-4.13Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.33,428.05c-5.36,4.46-46.65,32.8-105.57,28.23-3.17-26.82-15.26-137-1.51-154.28,0,0,33.36-15.91,64.09-9.23s42.69,13.08,44.88,18.62C420.88,315.58,418.51,393.6,417.33,428.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.32,304.54c-17.7,15.33-40.5,12.09-40,.32.08-1.84,2.05-4.12,2.05-4.12l-.69-1.06-3-4.53c-2.19-3.39-4.93-7.65-6.84-10.75-1.6-2.64,38.29-27.18,38.29-13.07,0,19.88,9.76,23.62,9.76,23.62C376.57,296.43,380,298.77,373.32,304.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.51,334.9s-3.57,12.24-1.88,15.75",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.34,299.36c0,11.81-35.23,23.38-45.55,11.53",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.36,285.73S349,294.63,338,301.58a4.12,4.12,0,0,0-2.37-1.87,3.11,3.11,0,0,0-1,0l-3-4.53C337.32,291.08,351.36,285.73,351.36,285.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.3,274.79s-.12,8.78-2,10.57c-13.95,13.38-27.59,14.44-29.84,10.91-15.15-23.76-11.57-30-13.11-34.07-2.73-7.14-6.08-18.8-4.6-25.86,3.3-15.77,33-28,48.64-12.14,7.5,7.59,9.87,24.06,8.29,37.78",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.26,254.86s-4.17-1.87-5.07.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.37,255s8.67-3.63,12.57.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,261.15c.14,1.3-.49,2.43-1.42,2.54s-1.79-.88-1.93-2.18.49-2.44,1.42-2.54S332.82,259.85,333,261.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,261.54c.15,1.3-.49,2.44-1.42,2.54s-1.79-.87-1.93-2.17.49-2.44,1.42-2.54S315.84,260.24,316,261.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.42,258.12c1.21,1.95.55,5.28-1.05,9.85s-.19,6.22,5.95,6.68",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.32,282.56s8-.73,11.66-2.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,237.22c0-5.94-5.86-18.13-16.14-19.5h0c-5.91-6.18-14.33-8.45-24.55-6.1-23.62,5.42-30.81,28.74-31.84,32.6-.1.36-.15.56-.15.56l6.32-1.6-2.72,5.31,3.31,2.19-.76.84,3.84,3.7-1.2-6.76c.74-4.36,5.76-10.46,5.76-10.46a16.31,16.31,0,0,0-3.3,8.19c2-5.19,14-10,14-10-3.89,3.16-6,9.34-6,9.34,3.7-4.56,12.37-7.51,17.92-9.08,1.87,4.51,4.84,9.22,9.08,11.83,4,2.46,3.86,7.54,3.86,7.54a23.32,23.32,0,0,1,9,12.36l4.84,6.62S372,264.09,372,237.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.63,257.52c-1.62-3.47,4.26-12.87,8.43-11.71,2.34.66,5.4,4.93,6,9.41s-2.57,13-5.95,14.85c-2.15,1.2-3.92-2.07-3.92-2.07",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.51 427.25 209.5 400.83 445.18 428.05 384.5 469.55 96.51 427.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "96.51 427.25 209.5 400.83 445.18 428.05",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.29 432.55 240.03 412.33 297.86 415.32 272.14 437.31 194.29 432.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.48,301c-14.67,6-17.83,19.49-42.76,72.8,0,0-11.07,2.27-17,15.72s4,24.07,15.43,23.71c0,0,4.59,4,14,3.59s51-64.05,51-64.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09,376.93c6.56,5.84,10.33,14.41,8.33,23.91",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.42,379.74s8.06,1.76,9.31,12.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,349.54a58.84,58.84,0,0,1-3.82-29.67",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.86,335.94c-.61,4.2,3.73,26.56,3.7,50.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.52,305.42c18.35,9.22,20.53,37.59,3.22,71.51-12.23,23.94-29.11,59.29-39.79,61.66s-21.1-4.28-21.1-4.28-9-.42-11.72-6.82C335.69,410,354.6,387.9,362,393.19c0,0,23.76-51.67,28.09-54.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.43,416.86C339,404.79,358,390.55,362,393.19c0,0,14.11.79,16.22,10.55",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,419.43c8.26-14.57,22.62-42.5,22.62-42.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,393.19s9.89-5.92,17.28-.32",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.38,386s5.46-12,11-23,18.22-27.29,23.49-28.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.16,407.57a8.14,8.14,0,0,1-3.4-.93c-17-8.87-30.22-23.53-38.18-34.05A125.73,125.73,0,0,1,211.05,360l4.08-17.48s3.84,10,19.27,19.83,33.76,13.07,39.69,23C279.34,394,270.09,408,261.16,407.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.16,407.57a16.55,16.55,0,0,0-1-3.69c-3.57-8.94-25.17-26.71-25.17-26.71-5.14-.16-10.79-2.3-15.39-4.58A125.73,125.73,0,0,1,211.05,360l4.08-17.48s3.84,10,19.27,19.83,33.76,13.07,39.69,23C279.34,394,270.09,408,261.16,407.57Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.16,407.57a8.14,8.14,0,0,1-3.4-.93c-17-8.87-30.22-23.53-38.18-34.05A125.73,125.73,0,0,1,211.05,360l4.08-17.48s3.84,10,19.27,19.83,33.76,13.07,39.69,23C279.34,394,270.09,408,261.16,407.57Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.66,358.94s-2.11,9.32-7.67,7.23c-3-1.13-8.78-10.09-9.87-14.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15,301.55l4.54-2.34s12.83.11,20.79,6.58c7.23,5.88,10.9,15.09,10.9,15.09s28.09-15.51,56.78-6.61l11.7,65.21L249.07,383,215.5,351.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.56,382.09s-6.31-.19-14.75.09c-12.76.4-30.39,1.84-38.45,6.53l-.38-.13L245.6,386l-.15-.22c-1.36-2-12.33-17.75-28-24.16l-22.16-61.92s23,1,35.57,21.78l6.31,2.28s37.55-11.12,58.57-7.12Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.45,385.79c-1.36-2-12.33-17.75-28-24.16l-22.16-61.92s23,1,35.57,21.78Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.81,382.18c-12.76.4-30.39,1.84-38.45,6.53l-.38-.13L238.24,326s12.06-2.71,15.77-1.34C254,324.68,278.52,342.77,291.81,382.18Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.56,382.09s-6.31-.19-14.75.09c-12.76.4-30.39,1.84-38.45,6.53l-.38-.13L245.6,386l-.15-.22c-1.36-2-12.33-17.75-28-24.16l-22.16-61.92s23,1,35.57,21.78l6.31,2.28s37.55-11.12,58.57-7.12Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.19,
    y1: 323.77,
    x2: 251.66,
    y2: 383.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.6,
    y1: 386.01,
    x2: 231.54,
    y2: 326.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.88,360.05c-3.21-.89-9.68-20.18-6.72-28.49,0,0,3.52-6.11,5-6.53,2.24-.65,11.28-.46,10.84,1.06-1,3.52-7.94,3.46-7.94,3.46l-2.25,4.12.09,2.27s3.27-2.38,4.47-2.31c.62,0,3.82,1.6,6.36,2.94,2.17,1.15,3.5,1.78,3,2.82-1.61,3.46-8.46,1-8.46,1l-2.58,3.89s2.49.43,3.58.55,10.14,6.15,9.87,6.9c-1.07,2.94-9.65-.24-9.65-.24l-1.52,1.27s6.32,1.63,7,1.87c1,.37,4.85,3.33,4.79,3.67-.46,2.6-5.77.69-5.77.69l-4.65-.19a5.72,5.72,0,0,1-2.48,1.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.86,335.94s-3,2.52-3.77,3.25-.58,3.05-.58,3.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.69,347.36c0,2.54,1.7,4.08,2.48,4.9s-1.25,3.05,1,4.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.81,427.87c-6.35,1.73-13.25-9.43-21.67-21.61h0c-5.56-8-11.78-16.53-18.93-22-.57-.43-1.15-.85-1.73-1.25l4.18-21c8.68,4.55,14.06,11.84,23.07,19.33,14.5,12.07,27.35,19.48,30.91,24.82S365.69,424.9,354.81,427.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.14,406.25c-5.56-8-11.78-16.53-18.93-22a7,7,0,0,0,2.77-.42S328.28,393,333.14,406.25Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.81,427.87c-6.35,1.73-13.25-9.43-21.67-21.61h0c-5.56-8-11.78-16.53-18.93-22-.57-.43-1.15-.85-1.73-1.25l4.18-21c8.68,4.55,14.06,11.84,23.07,19.33,14.5,12.07,27.35,19.48,30.91,24.82S365.69,424.9,354.81,427.87Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,382.18a3.47,3.47,0,0,1-2,1.62,7,7,0,0,1-.69.23l-.19,0c-6.71,1.75-21.81-1.89-21.81-1.89s-9.89-4.7-10.49-5.81a27.22,27.22,0,0,1-1.11-2.7l-.27-.79s-3.56-2-4-3.56-1.19-2,1-2.28,14,0,14,0l-12.85-5.24s-8.51-4.29-9.3-5.8-1.78-2.51,2.57-1.91,13.85,3.36,13.85,3.36L295.2,359l-7.44-3.17s-14.64-1.77-11.87-6.32h8.31a85.79,85.79,0,0,1,14,1.78c2.42.74,18.42,10.68,18.42,10.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.1,384.07c-6.71,1.75-21.81-1.89-21.81-1.89s-9.89-4.7-10.49-5.81a27.22,27.22,0,0,1-1.11-2.7L294.83,375a5.15,5.15,0,0,0,0,5C296.18,382.43,311.56,384.89,316.1,384.07Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319,382.18a3.47,3.47,0,0,1-2,1.62,7,7,0,0,1-.69.23l-.19,0c-6.71,1.75-21.81-1.89-21.81-1.89s-9.89-4.7-10.49-5.81a27.22,27.22,0,0,1-1.11-2.7l-.27-.79s-3.56-2-4-3.56-1.19-2,1-2.28,14,0,14,0l-12.85-5.24s-8.51-4.29-9.3-5.8-1.78-2.51,2.57-1.91,13.85,3.36,13.85,3.36L295.2,359l-7.44-3.17s-14.64-1.77-11.87-6.32h8.31a85.79,85.79,0,0,1,14,1.78c2.42.74,18.42,10.68,18.42,10.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.42,
    y1: 372.88,
    x2: 297.03,
    y2: 375.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.78,417.62l36.62,11,67-15.29S199.48,401.71,199.1,402,136.78,417.62,136.78,417.62Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.78,417.62l36.62,11,67-15.29S199.48,401.71,199.1,402,136.78,417.62,136.78,417.62Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.78,417.62l36.62,11,67-15.29S199.48,401.71,199.1,402,136.78,417.62,136.78,417.62Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,404.72c-2.57.18-3.21,9.44-.53,12.9l59.16-12.28,4.74-11.22Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.31,404.72c-2.57.18-3.21,9.44-.53,12.9l59.16-12.28,4.74-11.22Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,404.72c-2.57.18-3.21,9.44-.53,12.9l59.16-12.28,4.74-11.22Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.53,404.59s-.88,4.87-.31,7.87l-63.89,14.46L139.65,417s-3.5-6.19-.45-11l61.54-10.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.31 404.72 200.68 394.12 240.03 404.09 173.85 417.28 137.31 404.72",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.56 410.64 173.07 420.62 227.92 409.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.04,
    y1: 410.6,
    x2: 178.06,
    y2: 423.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.35,414.57c.51.05,25.26,7.67,25.26,7.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.22,
    y1: 408.29,
    x2: 236.91,
    y2: 407.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.98,
    y1: 424.09,
    x2: 169.49,
    y2: 423.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.2,406a8.82,8.82,0,0,1,.45,11A10.41,10.41,0,0,1,139.2,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.2,406a8.82,8.82,0,0,1,.45,11A10.41,10.41,0,0,1,139.2,406Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.2,406a8.82,8.82,0,0,1,.45,11A10.41,10.41,0,0,1,139.2,406Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.07 420.62 340.02 423.24 333.79 445.25 255.12 442.25 276.07 420.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "276.07 420.62 340.02 423.24 333.79 445.25 255.12 442.25 276.07 420.62",
    style: {
      fill: "#90CAF9",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "276.07 420.62 340.02 423.24 333.79 445.25 255.12 442.25 276.07 420.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/Bed.6aef328f73f6693aeb49d6261b84b95b.svg";
export { ForwardRef as ReactComponent };